import { render, staticRenderFns } from "./DownloadPdf.vue?vue&type=template&id=fd72ca22&"
import script from "./DownloadPdf.vue?vue&type=script&lang=js&"
export * from "./DownloadPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports